module.exports = __webpack_public_path__ + "img/id.cfcb605d.svg";